import React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

const UTMLink = ({ to, children, ...otherProps }) => {
  const utmData = useLocation().search;
  const withHash = /#/.test(to);
  const utmTo = withHash ? `/${utmData}#${to.split("#")[1]}` : to + utmData;
  return (
    <Link to={utmTo} {...otherProps}>
      {children}
    </Link>
  );
};
export default UTMLink;
